<ul class="nav nav-tabs justify-content-start">
  <li *ngIf="hasRole(TipoUsuario.TUTOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE, TipoUsuario.CONSAEROVALES)" class="nav-item">
    <a class="nav-link" routerLink="stock" routerLinkActive="active">Stock</a>
  </li>
  <li *ngIf="hasRole(TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_AV, TipoUsuario.COMERCIAL_LN, TipoUsuario.APROBADORBYR, TipoUsuario.FACTURACION, TipoUsuario.REFACTURACION, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.RESPRODUCTO, TipoUsuario.EJECUTIVOCUENTA)" class="nav-item">
    <a class="nav-link" routerLink="legajos" routerLinkActive="active">Legajo de anulaciones</a>
  </li>
  <li *ngIf="hasRole(TipoUsuario.TUTOR, TipoUsuario.SUPERVISOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE, TipoUsuario.RESPRODUCTO, TipoUsuario.CONSAEROVALES)" class="nav-item">
    <a class="nav-link" routerLink="informes" routerLinkActive="active">Informes</a>
  </li>
  <li *ngIf="hasRole(TipoUsuario.FACTURACION, TipoUsuario.SOPORTE, TipoUsuario.SEGURIDADTABLAS)" class="nav-item">
    <a class="nav-link" routerLink="interfaces" routerLinkActive="active">Interfaces</a>
  </li>
</ul>

<router-outlet></router-outlet>
